const pagesBusinessPartnerEn = {
  add: {
    form: {
      fields: {
        addressAndOffice: {
          individual: {
            label: 'Individual Address',
            placeholder: 'Current address of the linked person'
          }
        },
        basicIdInformation: {
          businessPartnerActiveEndDate: {
            label: 'BP Active End Date',
            placeholder: 'Select BP active end date'
          },
          businessPartnerActivePeriod: {
            label: 'BP Active Period',
            placeholder: 'Select BP active period',
            specifyEndDate: 'Specify an End Date'
          },
          businessPartnerActiveStartDate: {
            label: 'BP Active Start Date',
            placeholder: 'Select BP active start date'
          },
          businessPartnerCode: {
            label: 'BP Code',
            placeholder: 'Enter BP code'
          },
          businessPartnerName: {
            label: 'Business Partner Name',
            placeholder: 'Enter business partner name'
          },
          businessPartnerRegistrationDate: {
            label: 'BP Registration Date',
            placeholder: 'Select BP registration date'
          },
          businessPartnerRoles: {
            error: 'Please select at least one BP role',
            label: 'BP Roles',
            placeholder: 'Select at least one BP role'
          },
          businessPartnerShortName: {
            label: 'Display Name / Short Name',
            placeholder: 'Enter display name / short name'
          },
          businessPartnerStatus: {
            label: 'BP Status',
            placeholder: 'Select BP status'
          },
          businessPartnerTerminationDate: {
            label: 'BP Termination Date',
            placeholder: 'Select BP termination date'
          }
        },
        contactsAndPersonInCharge: {
          billingEmail: {
            label: 'Billing Email',
            placeholder: 'Enter billing email'
          },
          contacts: {
            add: 'Add contact',
            columns: {
              email: {
                label: 'Email',
                placeholder: 'Enter email'
              },
              name: {
                label: 'Name',
                placeholder: 'Enter name'
              },
              phone: {
                label: 'Phone',
                placeholder: 'Enter phone'
              },
              position: {
                label: 'Position',
                placeholder: 'Enter position'
              },
              preference: {
                label: 'Preference',
                placeholder: 'Enter preference'
              }
            },
            label: 'Contacts',
            placeholder: 'Enter contacts'
          },
          faxNumber: {
            label: 'Fax Number',
            placeholder: 'Enter fax number'
          },
          genericEmail: {
            label: 'Generic Email',
            placeholder: 'Enter generic email'
          },
          individual: {
            label: 'Individual Contact',
            placeholder: 'Current contact of the linked person'
          },
          mainPhone: {
            label: 'Main Phone',
            placeholder: 'Enter main phone'
          },
          securityEmail: {
            label: 'Security Email',
            placeholder: 'Enter security email'
          },
          socialMediaLink: {
            add: 'Add social media links',
            label: 'Social Media Links',
            placeholder: 'Enter social media links'
          },
          supportPhone: {
            label: 'Support Phone',
            placeholder: 'Enter support phone'
          },
          websiteUrl: {
            add: 'Add website URL',
            label: 'Website URL',
            placeholder: 'Enter website URL'
          }
        },
        corporateIdInformation: {
          abbreviationTradeName: {
            label: 'Corporate Abbreviation/Trade Name',
            placeholder: 'Enter corporate abbreviation or trade name'
          },
          corporateId: {
            label: 'Corporate ID',
            placeholder: 'Enter corporate ID'
          },
          countryOfIncorporation: {
            label: 'Country of Incorporation',
            placeholder: 'Enter country (e.g., JP, US)'
          },
          duns: {
            label: 'DUNS',
            placeholder: 'Enter DUNS'
          },
          entityType: {
            label: 'Entity Type',
            placeholder: 'Enter entity type (e.g., Corporation, LLC)'
          },
          establishedDate: {
            label: 'Established Date',
            placeholder: 'Select established date'
          },
          legalName: {
            label: 'Corporate Legal Name',
            placeholder: 'Enter legal name'
          },
          lei: {
            label: 'LEI',
            placeholder: 'Enter LEI'
          },
          name: {
            label: 'Corporate Name',
            placeholder: 'Enter corporate name'
          },
          nameEnglish: {
            label: 'Corporate Name (English)',
            placeholder: 'Enter name in English'
          },
          nameForForms: {
            label: 'Corporate Name (for Forms)',
            placeholder: 'Enter name for forms'
          },
          nameKana: {
            label: 'Corporate Name (Kana)',
            placeholder: 'Enter corporate name in Kana'
          },
          primaryLanguage: {
            label: 'Primary Language',
            placeholder: 'Select primary language'
          },
          registrationNumber: {
            label: 'Registration Number',
            placeholder: 'Enter registration number'
          },
          status: {
            label: 'Corporate Status',
            placeholder: 'Select corporate status'
          },
          tagline: {
            label: 'Tagline',
            placeholder: 'Enter tagline'
          },
          taxId: {
            label: 'Tax ID',
            placeholder: 'Enter tax ID'
          },
          timeZone: {
            label: 'Time Zone',
            placeholder: 'Select time zone'
          },
          transactionCurrency: {
            label: 'Preferred Currency',
            placeholder: 'Select currency'
          }
        },
        individualIdInformation: {
          personId: {
            label: 'Linked Person',
            placeholder: 'Select linked person'
          }
        }
      },
      navigation: {
        common: {
          submitButtonLabel: 'Add Business Partner'
        },
        completed: {
          completedBy: 'Completed by:',
          continueAdding: 'Continue adding another Business Partner',
          goToBusinessPartner: 'Go to Details',
          message: 'Business Partner added.',
          result: 'Result'
        },
        steps: {
          addressAndOffice: {
            title: 'Address & Office'
          },
          basicIdInformation: {
            title: 'Business Partner ID Information'
          },
          contactsAndPersonInCharge: {
            title: 'Contacts & Person in Charge'
          },
          corporateIdInformation: {
            title: 'Corporate ID Information'
          },
          individualIdInformation: {
            title: 'Individual ID Information'
          }
        },
        title: 'Business Partner Registration'
      },
      progressbar: {
        filled: 'filled',
        modeSetting: 'Mode Settings',
        mustItem: 'Required Items',
        mustItemOnly: 'Required items only',
        total: 'Total'
      }
    },
    intro: {
      body: {
        fillOutDetails: 'Fill out the details',
        itemCard: {
          requiredDetails: 'Required details:'
        },
        selectBusinessPartnerType: 'Select Business Partner Type:'
      },
      header: {
        headerTitle: 'Add Business Partner'
      },
      options: {
        bulkCsvUpload: {
          button: 'Prepare csv file',
          description: 'You can add data for multiple business partners, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
          selectedType: 'Type:',
          selectedTypeTitle: {
            corporation: 'Corporation',
            individual: 'Individual'
          },
          title: 'Bulk add by uploading a csv file'
        }
      }
    }
  },
  addContact: 'Add Contact',
  detail: {
    body: {
      createRole: {
        customerButton: 'Add customer information',
        notGeneratedMessage: 'The information for this role has not been created yet.',
        supplierButton: 'Add supplier information'
      },
      errors: {
        businessPartnerIdLabel: 'Business Partner ID: {{id}}',
        businessPartnerNotFound: 'Business partner details not found',
        dataLoadFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred'
      },
      groups: {
        addressAndContact: 'Address & Contact',
        bpRoleInfo: 'BP Role Info',
        detail: 'Detail'
      },
      labels: {
        businessPartnerRole: 'BP Role'
      },
      noBpRolesMessage: 'This business partner has no BP roles assigned. Assign roles on the Detail tab.',
      noDataMessage: 'No data available in this section.',
      redirecting: 'Redirecting…'
    },
    header: {
      activePeriod: 'BP Active Period',
      dataLoadFailed: 'Failed to load business partner header data',
      status: 'BP Status',
      type: 'BP Type'
    },
    tabs: {
      addressAndContact: 'Address & Contact',
      bpRoleInfo: 'BP Role Info',
      detail: 'Detail'
    }
  },
  importCsv: {
    businessPartnerType: {
      filename: {
        corporation: 'Corporation',
        individual: 'Individual'
      },
      prepareCsvFile: {
        templateTitle: {
          corporation: 'New corporations',
          individual: 'New individuals'
        },
        updateExisting: {
          corporation: 'Update existing corporations',
          individual: 'Update existing individuals'
        }
      },
      title: {
        corporation: 'Bulk Add Corporation',
        individual: 'Bulk Add Individual'
      },
      unit: {
        corporations: 'corporations',
        individuals: 'individuals'
      }
    },
    checkValidColumn: {
      errors: 'Errors',
      warnings: 'Warnings'
    },
    completeDialog: {
      button: 'Go to Business Partners'
    }
  },
  list: {
    actions: {
      export: 'Export',
      share: 'Share'
    },
    addBusinessPartner: 'Add Business Partner',
    businessPartnerActivePeriod: 'BP Active Period',
    businessPartnerAddress: 'Address',
    businessPartnerName: 'Business Partner Name',
    businessPartnerRegistrationDate: 'BP Registration Date',
    businessPartnerRole: 'BP Role',
    businessPartnerStatus: 'BP Status',
    businessPartnerTerminationDate: 'BP Termination Date',
    businessPartnerType: 'BP Type',
    filterPlaceholder: 'Search by BP Name...',
    filters: {
      businessPartnerType: 'Business Partner Type',
      businessPartnerTypePlaceholder: 'Search by business partner type'
    },
    pageTitle: 'Business Partners',
    tabs: {
      all: 'All',
      corporation: 'Corporation',
      group: 'Group',
      individual: 'Individual'
    }
  },
  overview: {
    eventType: {
      BUSINESS_PARTNER_CREATED: 'Business partner "{{name}}" was created',
      BUSINESS_PARTNER_CSV_IMPORT_CREATED: 'Business partner "{{name}}" was created via CSV import',
      BUSINESS_PARTNER_CSV_IMPORT_UPDATED: 'Business partner "{{name}}" was updated via CSV import',
      BUSINESS_PARTNER_UPDATED: 'Business partner "{{name}}" was updated'
    },
    recent: {
      empty: 'No recently added business partners',
      title: 'Recently added business partners'
    },
    role: {
      CUSTOMER: 'Customer',
      EMPLOYEE: 'Employee',
      FINANCIAL_INSTITUTION: 'Financial institution',
      RESELLER_AGENT: 'Reseller / agent',
      SUPPLIER: 'Supplier'
    },
    slot: {
      activity: {
        empty: 'No recent activity',
        title: 'Recent Activity'
      },
      role: {
        title: 'Partner role'
      },
      status: {
        title: 'Partner status'
      },
      total: {
        title: 'Business Partners'
      },
      type: {
        title: 'Partner type'
      }
    },
    status: {
      ACTIVE: 'Active',
      DRAFT: 'Draft',
      PENDING_APPROVAL: 'Pending approval',
      REJECTED: 'Rejected',
      SUSPENDED: 'Suspended',
      TERMINATED: 'Terminated',
      UNDER_REVIEW: 'Under review'
    },
    unit: {
      cases: 'partners',
      types: 'types'
    }
  },
  type: {
    corporation: 'Corporation',
    group: 'Group',
    individual: 'Individual'
  }
};
export default pagesBusinessPartnerEn;